import type { Router } from "vue-router";
import { canNavigate } from "@layouts/plugins/casl";
import { loader } from "@/components/loader/loader";
import { analytics } from "@/firebase";
import { event } from "@/firebase/analytics";

const oldRoutes: Record<string, string> = {
  "/auth/login": "/login",
  "/auth/register": "/register",
};

export const setupGuards = (router: Router) => {
  // 👉 router.beforeEach
  // Docs: https://router.vuejs.org/guide/advanced/navigation-guards.html#global-before-guards
  router.beforeEach((to, from) => {
    if (to.path !== from.path) {
      loader.start();
      analytics.logEvent(event.PageView, {
        page_path: to.path,
        page_title: to.name,
      });
    }

    // Redirect old routes to new routes
    if (oldRoutes[to.path]) {
      return oldRoutes[to.path];
    }

    /*
     * If it's a public route, continue navigation. This kind of pages are allowed to visited by login & non-login users. Basically, without any restrictions.
     * Examples of public routes are, 404, under maintenance, etc.
     */
    if (to.meta.public) return;

    /**
     * Check if user is logged in by checking if token & user data exists in local storage
     * Feel free to update this logic to suit your needs
     */
    const isLoggedIn = !!(
      useCookie("userData").value && useCookie("accessToken").value
    );

    /*
      If user is logged in and is trying to access login like page, redirect to home
      else allow visiting the page
      (WARN: Don't allow executing further by return statement because next code will check for permissions)
     */
    if (to.meta.unauthenticatedOnly) {
      if (isLoggedIn) {
        // return "/dashboard";
      } else return undefined;
    }

    if (!canNavigate(to) && to.matched.length) {
      /* eslint-disable indent */
      return isLoggedIn
        ? { name: "error-401" }
        : {
            name: "login",
            query: {
              ...to.query,
              to: to.fullPath !== "/" ? to.path : undefined,
            },
          };
      /* eslint-enable indent */
    }
  });
};
